export const HAS_AI_FAQS_ENABLED = true
export const HAS_MAIN_IMAGE_ENABLED = true
export const HAS_ALERTS_ON_LEAD_ENABLED = true
export const HAS_APP_SUGGESTION_DRAWER_ENABLED = true
export const HAS_AD_DETAIL_TRUST_CERTIFICATION_ENABLED = true
export const HAS_AD_DETAIL_TRUST_CARFAX_ENABLED = true
export const HAS_AD_DETAIL_TECHNICAL_DATASHEET_ENABLED = true
export const HAS_AD_DETAIL_EXTRAS_PRICE_ENABLED = true
export const HAS_CSAT_NPS_ENABLED = true
export const HAS_CSAT_BUYER_ENABLED = false
